module.exports = __webpack_public_path__ + "img/quotation-marks.6cfe258d.svg";